import * as Storage from "../utils/storage";
import * as API from "../utils/api";

import { IDENTIFICATION_MODAL_ERRORS } from "../constants/error_messages";
import { SURVEY_STATUS } from "../constants/survey_status";

export const loadSurveyStatus = (needsValidation) => {
  if (needsValidation) {
    return SURVEY_STATUS.PENDING;
  }

  return Storage.getItem(["surveyRespondentData", "surveyStatus"]) ?? SURVEY_STATUS.PENDING;
};

export const validateRespondent = async (surveyId, respondentIdType, respondentId, password) => {
  const parameters = {
    survey_id: surveyId,
    identificator_type: respondentIdType,
    value: respondentId,
  };

  if (password) {
    const areCredentialsValid = await API.checkIfCredentialsValid(parameters, password);
    if (!areCredentialsValid) {
      return {
        response: "rejected",
        error: IDENTIFICATION_MODAL_ERRORS.CREDENTIALS_NOT_VALID(respondentIdType),
      };
    }
  }

  const surveyLinkedToApplicantGroup = await API.checkIfSurveyLinkedToApplicantGroup(parameters);

  if (surveyLinkedToApplicantGroup) {
    const applicantSessionCreated = await API.createApplicantSession(parameters);
    if (!applicantSessionCreated) {
      return {
        response: "rejected",
        error: IDENTIFICATION_MODAL_ERRORS.NO_USER_FOUND(respondentIdType),
      };
    }

    const userCompletedSurvey = await API.checkUserAnswersStatus(parameters);
    if (userCompletedSurvey) {
      return {
        response: "rejected",
        error: IDENTIFICATION_MODAL_ERRORS.SURVEY_ALREADY_COMPLETED(),
      };
    }
  } else {
    const userCompletedSurvey = await API.checkUserAnswersStatus(parameters);
    if (userCompletedSurvey) {
      return {
        response: "rejected",
        error: IDENTIFICATION_MODAL_ERRORS.SURVEY_ALREADY_COMPLETED(),
      };
    }
    await API.createNonApplicantSession(parameters);
  }

  return { response: "accepted" };
};

// Restablece los datos de local storage para encuestas con autenticación en los
// casos que se describen a continuación.
export const updateStorage = ({
  respondentIdType,
  respondentId,
  isAnonymousSurvey,
  surveyId,
  surveyStatus,
}) => {
  if (surveyStatus === SURVEY_STATUS.AWAITING_LOGIN) {
    if (!isAnonymousSurvey) {
      return;
    }
  }

  if (surveyStatus === SURVEY_STATUS.DONE) {
    Storage.setItem("survey", {});
    return;
  }

  const surveyDataFromStorage = Storage.getItem("survey") ?? {};

  var updatedRespondentData = {
    ...(respondentIdType && { [respondentIdType]: respondentId }),
    surveyId,
    surveyStatus,
  };
  var updatedSurveyData = surveyDataFromStorage;

  // Si por alguna razón el usuario requiere desarrollar otra encuesta, estas líneas se hacen cargo de borrar todo rastro de un ingreso anterior
  const storageSurveyId = Storage.getItem(["surveyRespondentData", "surveyId"]);
  if (storageSurveyId !== surveyId) {
    updatedSurveyData["questionsVisibility"] = undefined;
    updatedSurveyData["answers"] = {};
  }

  // ---------------------

  if (respondentIdType) {
    // La finalidad de esto es evitar que múltiples sesiones de una misma encuesta no se intercedan si no son realizadas por el mismo usuario
    // (ej: si dos personas que comparten el mismo computador realizan la misma encuesta)
    const storageRespondentId = Storage.getItem(["surveyRespondentData", respondentIdType]);
    if (!storageRespondentId || storageRespondentId !== respondentId) {
      updatedSurveyData["questionsVisibility"] = undefined;

      // Chequeamos antes de borrar las respueatas de local storage si corresponde a una pregunta con identificación
      if (!isAnonymousSurvey) {
        updatedSurveyData["answers"] = {};
      }
    }
  }

  Storage.setItem("survey", updatedSurveyData);
  Storage.setItem("surveyRespondentData", updatedRespondentData);
};
